var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.3151C29.8833 2.3151 37.9167 10.3484 37.9167 20.2318C37.9167 30.1151 29.8833 38.1484 20 38.1484C10.1167 38.1484 2.08332 30.1151 2.08332 20.2318C2.08331 10.3484 10.1166 2.3151 20 2.3151ZM20 35.6484C28.5 35.6484 35.4167 28.7318 35.4167 20.2318C35.4167 11.7318 28.5 4.8151 20 4.8151C11.5 4.8151 4.58331 11.7318 4.58332 20.2318C4.58332 28.7318 11.5 35.6484 20 35.6484Z",
    fill: "#00A14B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.2152C20.3167 15.2152 20.6333 15.3319 20.8833 15.5819L26.7667 21.4652C27.25 21.9485 27.25 22.7485 26.7667 23.2319C26.2833 23.7152 25.4833 23.7152 25 23.2319L20 18.2319L15 23.2319C14.5167 23.7152 13.7167 23.7152 13.2333 23.2319C12.75 22.7485 12.75 21.9485 13.2333 21.4652L19.1167 15.5819C19.3667 15.3319 19.6833 15.2152 20 15.2152Z",
    fill: "#00A14B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/arrowTop.26b8877727e7265d6061c10c64a9e804.svg";
export { ForwardRef as ReactComponent };